var React = require('react');

function ArrowUpRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5625 3.5V8.375C9.5625 8.52418 9.50324 8.66726 9.39775 8.77275C9.29226 8.87824 9.14919 8.9375 9 8.9375C8.85082 8.9375 8.70774 8.87824 8.60225 8.77275C8.49676 8.66726 8.4375 8.52418 8.4375 8.375V4.85938L3.39797 9.89797C3.2923 10.0036 3.14897 10.063 2.99953 10.063C2.85009 10.063 2.70677 10.0036 2.60109 9.89797C2.49542 9.7923 2.43606 9.64897 2.43606 9.49953C2.43606 9.35009 2.49542 9.20677 2.60109 9.10109L7.64063 4.0625H4.125C3.97582 4.0625 3.83274 4.00324 3.72725 3.89775C3.62176 3.79226 3.5625 3.64918 3.5625 3.5C3.5625 3.35082 3.62176 3.20774 3.72725 3.10225C3.83274 2.99676 3.97582 2.9375 4.125 2.9375H9C9.14919 2.9375 9.29226 2.99676 9.39775 3.10225C9.50324 3.20774 9.5625 3.35082 9.5625 3.5Z","fill":"currentColor"}));
}

ArrowUpRight.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = ArrowUpRight;

ArrowUpRight.default = ArrowUpRight;
